import { User } from './user'
import { EvCarProfile } from './evCarProfile'
// import { EvTripCancellationRequest } from './evTripCancellationRequest'
// import { EvTripDamageReport } from './evTripDamageReport'
import { EvTripLog } from './evTripLog'
import { EvTripRating } from './evTripRating'
// import { EvTripsWaybill } from './evTripsWaybill'

export enum EvTripStatus {
  INCOMPLETE = 'incomplete',
  PENDING = 'pending',
  ACCEPTED = 'accepted',
  CANCELLED_BY_ADMIN = 'cancelled_by_admin',
  DECLINED_BY_HOST = 'declined_by_host',
  DECLINED_BY_RENTER = 'declined_by_renter',
  CANCELED_BY_HOST = 'cancelled_by_host',
  CANCELED_BY_RENTER = 'cancelled_by_renter',
  ONGOING = 'ongoing',
  FINISHED = 'finished',
  ON_HOLD = 'on_hold',
  RESERVED = 'reserved',
  COMPLETED = 'completed',
}

export enum EvTripPricingType {
  PER_MINUTE = 'per_minute',
  PER_HOUR = 'per_hour',
  PER_DAY = 'per_day',
  PAUSE_FREE = 'pause_free',
  RUSH_HOUR = 'rush_hour',
}

export interface EvTrip {
  id: string
  renter_id: string
  host_id: string
  ev_car_profile_id: string
  status: string
  pricing_type: EvTripPricingType

  start_date: string
  end_date: string | null
  start_time?: string // actual trip start time
  end_time?: string // actual trip end time
  reservation_start_time: string | null
  reservation_end_time: string | null

  start_location: string
  end_location: string
  pickupLocation: string | null
  returnLocation: string | null

  pause_used: boolean
  rating: number | null
  review: string | null

  pretrip_photo: any[]
  aftertrip_photo: any[]
  to_calculate_parameter_list: any[]

  total_pause_minutes: number
  start_pause: string
  end_pause: string
  deposit_amount: number
  start_price: number
  isDepositReturned: boolean
  time_up_to_100km_minutes: number
  time_above_to_100km_minutes: number
  amount_up_to_100km: number
  amount_above_to_100km: number
  price_per_minute_up_to_100_km_ev: number
  price_per_minute_above_100_km_ev: number
  price_per_hour_up_to_100_km_ev: number
  price_per_hour_above_100_km_ev: number
  pause_price_ev: number
  price_per_minute_ev: number
  price_per_hour_ev: number
  price_per_km_ev: number
  time_to_100_km: number | null
  amount_pause: number
  total_amount: number
  effective_total_amount?: number
  total_distance: number

  start_timer_free_pause: string
  start_timer_pretrip_photo: string
  end_timer_pretrip_photo: string
  end_timer_free_pause: string

  odometer_start_trip: number
  odometer_end_trip: number
  total_trip_distance: number

  extra_distance_km?: number
  max_distance_per_tariff?: number
  max_distance_per_tariff_hourly_package?: number
  max_distance_per_tariff_minute_package?: number

  created_at: string
  updated_at: string

  waybill_sent: boolean
  cancellation_time: string | null

  // Financial fields
  pause_amount?: number
  driving_amount_up_to_100?: number
  driving_amount_above_100?: number
  pause_duration?: number // in minutes
  driving_duration_up_to_100?: number // in minutes
  driving_duration_above_100?: number // in minutes
  deposit_frozen?: number
  deposit_charged?: number
  deposit_refunded?: number
  service_frozen?: number
  service_charged?: number
  service_refunded?: number
  fines_frozen?: number
  fines_charged?: number
  fines_refunded?: number
  discount_amount?: number
  discounts?: EvTripDiscount[]
  per_hour_breakdown?: {
    base_hour: {
      duration_minutes: number
      distance_km: number
      limit_km: number
      over_limit_km: number
      amount: number
      base_amount: number
      extra_km_amount: number
    }
    minute_phase: {
      total_duration_minutes: number
      total_distance_km: number
      limit_km: number
      over_limit_km: number
      under_limit_duration_minutes: number
      over_limit_duration_minutes: number
      amount: number
      base_amount: number
      extra_km_amount: number
    }
    extends?: {
      index: number
      start_time: string
      end_time: string
      duration_minutes: number
      distance_km: number
      limit_km: number
      over_limit_km: number
      amount: number
      base_amount: number
      extra_km_amount: number
    }[]
    pause: {
      duration_minutes: number
      amount: number
    }
    total_amount: number
  }
  rush_breakdown?: {
    rush_phase: {
      duration_minutes: number
      distance_km: number
      limit_km: number
      over_limit_km: number
      amount: number
      base_amount: number
      extra_km_amount: number
      start_time: string
      end_time: string
    }
    minute_phase: {
      total_duration_minutes: number
      total_distance_km: number
      limit_km: number
      over_limit_km: number
      under_limit_duration_minutes: number
      over_limit_duration_minutes: number
      amount: number
      base_amount: number
      extra_km_amount: number
    }
    minute_intervals?: {
      start_time: string
      end_time: string
      duration_minutes: number
      distance_km: number
      cost: number
      under_limit_duration: number
      over_limit_duration: number
      over_limit_km: number
      distance_cost: number
      time_cost: number
    }[]
    extends?: {
      index: number
      start_time: string
      end_time: string
      duration_minutes: number
      distance_km: number
      limit_km: number
      over_limit_km: number
      amount: number
      base_amount: number
      extra_km_amount: number
    }[]
    pause: {
      duration_minutes: number
      amount: number
    }
    discount_amount: number
    total_amount: number
    total_amount_before_discount: number
    deposit: string
  }
  per_day_breakdown?: {
    base_day: {
      duration_minutes: number
      distance_km: number
      limit_km: number
      over_limit_km: number
      amount: number
      base_amount: number
      extra_km_amount: number
    }
    extends?: {
      index: number
      start_time: string
      end_time: string
      duration_minutes: number
      distance_km: number
      limit_km: number
      over_limit_km: number
      amount: number
      base_amount: number
      extra_km_amount: number
    }[]
    minute_phase: {
      total_duration_minutes: number
      amount: number
      base_amount: number
      extra_km_amount: number
    }
    pause: {
      duration_minutes: number
      amount: number
    }
    discount_amount: number
    total_amount: number
    total_amount_before_discount: number
  }
  per_minute_breakdown?: {
    start_price: number
    duration_minutes: number
    distance_km: string
    limit_km: number
    base_amount: number
    over_limit_km: number
    extra_km_amount: number
    pause: {
      duration_minutes: number
      amount: number
    }
    total_amount: number
  }
}

export interface EvTripDiscount {
  id: string
  amount: number
  reason?: string
  admin_id?: string
  applied_at: string
}

export interface EvTripExtended extends EvTrip {
  renter: User
  ev_car_profile: EvCarProfile
  // cancellationRequests: EvTripCancellationRequest[]
  // damage_reports: EvTripDamageReport[]
  logs: EvTripLog[]
  ev_trip_rating?: EvTripRating
  waybill?: string
}
